// show-errors.component.ts
import { Component, Input } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';

@Component({
  selector: 'show-errors',
  template: `
   <ul *ngIf="shouldShowErrors()">
     <li style="color: red" *ngFor="let error of listOfErrors()">{{error}}</li>
   </ul>
 `,
})
export class ShowErrorsComponent {

  private static readonly errorMessages = {
    'required': (params) => params + '  is required',
    'minlength': (params) => 'The min number of characters is ' + params.requiredLength,
    'maxlength': (params) => 'The max allowed number of characters is ' + params.requiredLength,
    'pattern': (params) => 'Invalid Input',
    'years': (params) => params.message,
    'countryCity': (params) => params.message,
    'uniqueName': (params) => params.message,
    'telephoneNumbers': (params) => params.message,
    'telephoneNumber': (params) => params.message,
  };

  @Input()
  private control: AbstractControlDirective | AbstractControl;

  @Input()
  message: any;

  @Input()
  InvalidMessageInput: any;

  shouldShowErrors(): boolean {
    return this.control &&
      this.control.errors &&
      (this.control.invalid && this.control.touched);
  }

  listOfErrors(): string[] {
    var message = this.message.name;

    return Object.keys(this.control.errors)
      .map(field => this.getMessage(field, this.control.errors[field], message));
  }

  private getMessage(type: string, params: any, message) {

    if (type == "required") {
      return ShowErrorsComponent.errorMessages[type](message);
    }
    else if (type == "pattern" && message == "Password" || message == "New Password" || message == "Confirm Password") {
      return "Enter valid password";
    }
    else if (type == "pattern" && message == "Email") {
      return "Invalid UserName or email address.";
    }
    else if (type == "pattern" && message == "Mobile Number"){
      return "Digits Only.";
    }

    else {
      return ShowErrorsComponent.errorMessages[type](params);
    }
  }

}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/show-errors/show-errors.component.ts